(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-purpose"] && !Shopify.designMode) return;
  try {
    
  /**
   * ARIA タブ（role="tablist" / "tab" / "tabpanel"）の切り替え。
   * クリックと矢印キー・Home・End に対応し、切り替えてもページはスクロールしない。
   */
  class ScTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll(':scope > [role="tablist"] > [role="tab"]'));
      this.addEventListener('click', this.#onClick);
      this.addEventListener('keydown', this.#onKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#onClick);
      this.removeEventListener('keydown', this.#onKeydown);
    }

    #onClick = (event) => {
      const tab = event.target.closest('[role="tab"]');
      if (!tab || !this.tabs.includes(tab)) return;
      this.select(tab);
    };

    #onKeydown = (event) => {
      const index = this.tabs.indexOf(event.target);
      if (index === -1) return;

      const last = this.tabs.length - 1;
      const next = {
        ArrowRight: index === last ? 0 : index + 1,
        ArrowLeft: index === 0 ? last : index - 1,
        Home: 0,
        End: last,
      }[event.key];
      if (next === undefined) return;

      event.preventDefault();
      this.select(this.tabs[next]);
      this.tabs[next].focus({ preventScroll: true });
    };

    /** @param {HTMLElement} selected */
    select(selected) {
      for (const tab of this.tabs) {
        const active = tab === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        const panel = this.querySelector(`#${tab.getAttribute('aria-controls')}`);
        if (panel) panel.hidden = !active;
      }

      // 横スクロールするタブ列の中だけで、選んだタブを見える位置に寄せる（ページは動かさない）
      const list = selected.parentElement;
      if (list && list.scrollWidth > list.clientWidth) {
        const left = selected.offsetLeft - (list.clientWidth - selected.offsetWidth) / 2;
        list.scrollTo({ left, behavior: 'smooth' });
      }
    }
  }

  if (!customElements.get('sc-tabs')) customElements.define('sc-tabs', ScTabs);

  } catch(e) { console.error(e); }
})();
})();
